import { RESPONSE } from './mutation-types';

export default {
  [RESPONSE](state, data) {
    state.response = data;
  }
};



// WEBPACK FOOTER //
// src/store/modules/contact/mutations.js